// Noms de lieux algériens : latin (tel que renvoyé par SOGRAL) → arabe.
// Couvre les 58 wilayas + les communes/têtes-de-ligne les plus desservies depuis Alger.
// Clé = nom normalisé (majuscules, sans accents ni traits d'union). Repli : nom d'origine.

const AR: Record<string, string> = {
  // --- 58 wilayas ---
  ADRAR: 'أدرار',
  CHLEF: 'الشلف',
  LAGHOUAT: 'الأغواط',
  'OUM EL BOUAGHI': 'أم البواقي',
  BATNA: 'باتنة',
  BEJAIA: 'بجاية',
  BISKRA: 'بسكرة',
  BECHAR: 'بشار',
  BLIDA: 'البليدة',
  BOUIRA: 'البويرة',
  TAMANRASSET: 'تمنراست',
  TEBESSA: 'تبسة',
  TLEMCEN: 'تلمسان',
  TIARET: 'تيارت',
  'TIZI OUZOU': 'تيزي وزو',
  ALGER: 'الجزائر',
  DJELFA: 'الجلفة',
  JIJEL: 'جيجل',
  SETIF: 'سطيف',
  SAIDA: 'سعيدة',
  SKIKDA: 'سكيكدة',
  'SIDI BEL ABBES': 'سيدي بلعباس',
  ANNABA: 'عنابة',
  GUELMA: 'قالمة',
  CONSTANTINE: 'قسنطينة',
  MEDEA: 'المدية',
  MOSTAGANEM: 'مستغانم',
  MSILA: 'المسيلة',
  'M SILA': 'المسيلة',
  MASCARA: 'معسكر',
  OUARGLA: 'ورقلة',
  ORAN: 'وهران',
  'EL BAYADH': 'البيض',
  ILLIZI: 'إليزي',
  'BORDJ BOU ARRERIDJ': 'برج بوعريريج',
  BOUMERDES: 'بومرداس',
  'EL TARF': 'الطارف',
  TINDOUF: 'تندوف',
  TISSEMSILT: 'تيسمسيلت',
  'EL OUED': 'الوادي',
  KHENCHELA: 'خنشلة',
  'SOUK AHRAS': 'سوق أهراس',
  TIPAZA: 'تيبازة',
  MILA: 'ميلة',
  'AIN DEFLA': 'عين الدفلى',
  NAAMA: 'النعامة',
  'AIN TEMOUCHENT': 'عين تموشنت',
  GHARDAIA: 'غرداية',
  RELIZANE: 'غليزان',
  TIMIMOUN: 'تيميمون',
  'BORDJ BADJI MOKHTAR': 'برج باجي مختار',
  'OULED DJELLAL': 'أولاد جلال',
  'BENI ABBES': 'بني عباس',
  'IN SALAH': 'عين صالح',
  'IN GUEZZAM': 'عين قزام',
  TOUGGOURT: 'تقرت',
  DJANET: 'جانت',
  'EL MGHAIR': 'المغير',
  'EL M GHAIR': 'المغير',
  'EL MENIAA': 'المنيعة',

  // --- communes / têtes-de-ligne courantes ---
  AZAZGA: 'أزازقة',
  FREHA: 'فريحة',
  'DRAA EL MIZAN': 'دراع الميزان',
  'DRAA BEN KHEDDA': 'دراع بن خدة',
  'LARBAA NATH IRATHEN': 'لاربعاء ناث إيراثن',
  'AIN EL HAMMAM': 'عين الحمام',
  TIGZIRT: 'تيقزيرت',
  AZEFFOUN: 'أزفون',
  BOGHNI: 'بوغني',
  OUADHIA: 'الوادية',
  MEKLA: 'مقلة',
  'BENI DOUALA': 'بني دوالة',
  AKBOU: 'أقبو',
  KHERRATA: 'خراطة',
  'EL KSEUR': 'القصر',
  AOKAS: 'أوقاس',
  'SOUK EL HAD': 'سوق الحد',
  'SOUK EL TENINE': 'سوق الإثنين',
  'BORDJ MENAIEL': 'برج منايل',
  THENIA: 'الثنية',
  DELLYS: 'دلس',
  ISSER: 'يسر',
  NACIRIA: 'الناصرية',
  LAKHDARIA: 'الأخضرية',
  'SOUR EL GHOZLANE': 'سور الغزلان',
  MCHEDALLAH: 'مشدالة',
  'M CHEDALLAH': 'مشدالة',
  'AIN BESSEM': 'عين بسام',
  'EL EULMA': 'العلمة',
  'AIN OULMENE': 'عين ولمان',
  BOUGAA: 'بوقاعة',
  'BOU SAADA': 'بوسعادة',
  'SIDI AISSA': 'سيدي عيسى',
  MAGRA: 'مقرة',
  BARIKA: 'بريكة',
  ARRIS: 'آريس',
  MEROUANA: 'مروانة',
  'AIN BEIDA': 'عين البيضاء',
  'AIN MLILA': 'عين مليلة',
  'AIN FAKROUN': 'عين فكرون',
  'EL KHROUB': 'الخروب',
  'HAMMA BOUZIANE': 'حامة بوزيان',
  'AIN ABID': 'عين عبيد',
  'CHELGHOUM LAID': 'شلغوم العيد',
  FERDJIOUA: 'فرجيوة',
  TAHER: 'الطاهير',
  'EL MILIA': 'الميلية',
  AZZABA: 'عزابة',
  COLLO: 'القل',
  'EL HARROUCH': 'الحروش',
  'EL HADJAR': 'الحجار',
  BERRAHAL: 'برحال',
  'OUED ZENATI': 'وادي الزناتي',
  SEDRATA: 'سدراتة',
  'BIR EL ATER': 'بئر العاتر',
  CHERIA: 'الشريعة',
  OUENZA: 'الونزة',
  BOUTALEB: 'بوطالب',
  KAIS: 'قايس',
  TOLGA: 'طولقة',
  'SIDI OKBA': 'سيدي عقبة',
  DJAMAA: 'جامعة',
  GUEMAR: 'قمار',
  MESSAAD: 'مسعد',
  'AIN OUSSERA': 'عين وسارة',
  'HASSI BAHBAH': 'حاسي بحبح',
  AFLOU: 'أفلو',
  'HASSI MESSAOUD': 'حاسي مسعود',
  METLILI: 'متليلي',
  BERRIANE: 'بريان',
  CHERCHELL: 'شرشال',
  KOLEA: 'القليعة',
  HADJOUT: 'حجوط',
  'KHEMIS MILIANA': 'خميس مليانة',
  MILIANA: 'مليانة',
  BERROUAGHIA: 'برواقية',
  'KSAR EL BOUKHARI': 'قصر البخاري',
  TENES: 'تنس',
  'OUED FODDA': 'وادي الفضة',
  'OUED RHIOU': 'وادي رهيو',
  SIG: 'سيق',
  MOHAMMADIA: 'المحمدية',
  TELAGH: 'تلاغ',
  MAGHNIA: 'مغنية',
  GHAZAOUET: 'الغزوات',
  REMCHI: 'الرمشي',
  NEDROMA: 'ندرومة',
  ARZEW: 'أرزيو',
  'AIN TURK': 'عين الترك',
  'ES SENIA': 'السانية',
  'BENI SAF': 'بني صاف',
  'HAMMAM BOUHADJAR': 'حمام بوحجر',
  FRENDA: 'فرندة',
  SOUGUEUR: 'سوقر',
  'THENIET EL HAD': 'ثنية الحد',
  MECHERIA: 'المشرية',
  'RAS EL OUED': 'رأس الوادي',
};

function normalizePlace(s: string): string {
  return s
    .toUpperCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/['’`._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Renvoie le nom du lieu en arabe si connu, sinon le nom d'origine. En FR, inchangé. */
export function localizePlace(name: string, lang: string): string {
  if (lang !== 'ar' || !name) return name;
  return AR[normalizePlace(name)] ?? name;
}
